import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import StepNumber from '@/components/stepper/StepNumber.vue';
import { STEP_STATUS } from '@/components/stepper/stepper.types';
import { computed, onMounted, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Step',
  props: {
    number: null,
    name: null,
    status: null
  },
  setup(__props: any) {

const props = __props as {
  number: number | string;
  name: string;
  status: STEP_STATUS;
}



const isLastStep = ref(false);

const stepClass = computed(() => {
  let cls = isLastStep.value ? 'step-last ' : '';
  cls += props.status ? `step-${props.status}` : '';
  return cls;
});

onMounted(() => (isLastStep.value = props.number === document.querySelectorAll('.step').length));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["step", _unref(stepClass)])
    }, [
      _createVNode(StepNumber, {
        number: __props.number,
        status: __props.status
      }, null, 8, ["number", "status"]),
      _createElementVNode("div", {
        class: _normalizeClass(["step-name", { 'text-muted': !__props.status }])
      }, _toDisplayString(__props.name), 3)
    ], 2)
  ]))
}
}

})